export default "__VITE_ASSET__BBkMieQw__"